import * as React from 'react';
import { SVGProps } from 'react';

const IconCodeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 3.589c0-1.154.935-2.089 2.089-2.089H5v1h-.411C3.987 2.5 3.5 2.988 3.5 3.59c0 .62-.275 1.208-.752 1.605L2 5.817v.365l.748.624c.477.397.752.985.752 1.605 0 .601.488 1.09 1.09 1.09H5v1h-.41A2.09 2.09 0 0 1 2.5 8.41c0-.323-.144-.63-.392-.837L1 6.651V5.349l1.108-.924c.248-.206.392-.513.392-.836ZM7.63 2.5H7v-1h.63A1.87 1.87 0 0 1 9.5 3.37c0 .462.205.9.56 1.195l.94.784V6.65l-.94.783c-.355.296-.56.734-.56 1.195A1.87 1.87 0 0 1 7.63 10.5H7v-1h.63c.48 0 .87-.39.87-.87 0-.76.337-1.478.92-1.964l.58-.484v-.365l-.58-.483A2.555 2.555 0 0 1 8.5 3.37a.87.87 0 0 0-.87-.87Zm-.183 1.724-2 4-.894-.448 2-4 .894.448Z" />
  </svg>
);
export default IconCodeSizeS;
